{
  "author": "OpenResearch",
  "engines": {
    "npm": "11.13.0"
  },
  "packageManager": "npm@11.13.0",
  "dependencies": {
    "@angular/animations": "~21.0.0",
    "@angular/cdk": "~21.0.0",
    "@angular/common": "~21.0.0",
    "@angular/core": "~21.0.0",
    "@angular/forms": "~21.0.0",
    "@angular/platform-browser": "~21.0.0",
    "@angular/platform-browser-dynamic": "~21.0.0",
    "@angular/router": "~21.0.0",
    "@angular/service-worker": "~21.0.0",
    "@awesome-cordova-plugins/android-permissions": "^6.13.0",
    "@awesome-cordova-plugins/core": "^6.13.0",
    "@awesome-cordova-plugins/email-composer": "^6.13.0",
    "@awesome-cordova-plugins/web-intent": "^6.13.0",
    "@capacitor-community/fcm": "^8.0.0",
    "@capacitor-community/firebase-analytics": "^8.0.0",
    "@capacitor/android": "^8.0.0",
    "@capacitor/app": "^8.0.0",
    "@capacitor/barcode-scanner": "^3.0.0",
    "@capacitor/browser": "^8.0.3",
    "@capacitor/camera": "^8.0.0",
    "@capacitor/clipboard": "^8.0.0",
    "@capacitor/core": "^8.0.0",
    "@capacitor/device": "^8.0.0",
    "@capacitor/filesystem": "^8.0.0",
    "@capacitor/geolocation": "^8.0.0",
    "@capacitor/haptics": "^8.0.0",
    "@capacitor/ios": "^8.0.0",
    "@capacitor/keyboard": "^8.0.0",
    "@capacitor/network": "^8.0.0",
    "@capacitor/preferences": "^8.0.0",
    "@capacitor/push-notifications": "^8.0.0",
    "@capacitor/screen-orientation": "^8.0.0",
    "@capacitor/status-bar": "^8.0.0",
    "@capacitor/text-zoom": "^8.0.0",
    "@capawesome/capacitor-file-picker": "^8.0.0",
    "@ionic/angular": "^8.5.0",
    "@ionic/cli": "^7.2.0",
    "@microsoft/fetch-event-source": "^2.0.1",
    "@ngbracket/ngx-layout": "^21.0.0",
    "@ngrx/effects": "21.0.1",
    "@ngrx/entity": "21.0.1",
    "@ngrx/signals": "21.0.1",
    "@ngrx/store": "21.0.1",
    "@ngrx/store-devtools": "21.0.1",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "@nx/angular": "22.3.3",
    "@primeuix/themes": "^2.0.2",
    "@sentry/angular": "^10.0.0",
    "@sentry/cli": "^2.40.0",
    "@tiptap/core": "^3.22.5",
    "@tiptap/extension-character-count": "^3.22.5",
    "@tiptap/extension-image": "^3.22.5",
    "@tiptap/extension-link": "^3.22.5",
    "@tiptap/extension-mention": "^3.22.5",
    "@tiptap/extension-placeholder": "^3.22.5",
    "@tiptap/starter-kit": "^3.22.5",
    "@tiptap/suggestion": "^3.22.5",
    "@types/echarts": "^4.9.22",
    "@types/file-saver-es": "^2.0.3",
    "@types/uuid": "^10.0.0",
    "@typescript-eslint/utils": "^8.29.0",
    "angular-oauth2-oidc": "^20.0.2",
    "awesome-phonenumber": "^7.2.0",
    "com-darryncampbell-cordova-plugin-intent": "^2.2.0",
    "cordova-plugin-android-permissions": "^1.1.5",
    "cordova-plugin-email-composer": "^0.10.1",
    "core-js": "^3.39.0",
    "date-fns": "^4.1.0",
    "dompurify": "^3.4.1",
    "echarts": "^6.0.0",
    "env-paths": "^3.0.0",
    "eslint-plugin-unused-imports": "^4.1.4",
    "fflate": "^0.8.3",
    "file-saver-es": "^2.0.5",
    "find-cache-dir": "^5.0.0",
    "glob": "^11.0.1",
    "handlebars": "^4.7.8",
    "jwt-decode": "^4.0.0",
    "kleur": "^4.1.5",
    "koa": "2.16.3",
    "mapbox-gl": "^3.5.0",
    "marked": "^17.0.6",
    "native-run": "^2.0.1",
    "ng2-pdf-viewer": "^10.4.0",
    "ngx-markdown": "^21.2.0",
    "ngx-mask": "^20.0.0",
    "ngx-toastr": "^19.0.0",
    "open": "^10.1.0",
    "plist": "^3.1.0",
    "primeflex": "^4.0.0",
    "primeicons": "^7.0.0",
    "primeng": "21.0.2",
    "prompts": "^2.4.2",
    "qrcode": "^1.5.4",
    "rxjs": "^7.8.1",
    "schema-utils": "^4.3.2",
    "semver": "^7.6.3",
    "signature_pad": "^5.0.4",
    "swiper": "^12.0.0",
    "tar": "^7.4.3",
    "tiny-lru": "^11.4.7",
    "tiptap-markdown": "^0.9.0",
    "trim-canvas": "^0.1.2",
    "tslib": "^2.8.1",
    "uuid": "^11.0.4",
    "xml2js": "^0.6.2",
    "zone.js": "0.16.0"
  },
  "description": "Monorepo for Tourfold frontend",
  "devDependencies": {
    "@angular-devkit/architect": "^0.2100.0",
    "@angular-devkit/build-angular": "^21.0.0",
    "@angular-devkit/core": "^21.0.0",
    "@angular-devkit/schematics": "^21.0.0",
    "@angular-eslint/builder": "21.1.0",
    "@angular-eslint/eslint-plugin": "21.1.0",
    "@angular-eslint/eslint-plugin-template": "21.1.0",
    "@angular-eslint/schematics": "21.1.0",
    "@angular-eslint/template-parser": "21.1.0",
    "@angular/build": "~21.0.0",
    "@angular/cli": "~21.0.0",
    "@angular/compiler": "~21.0.0",
    "@angular/compiler-cli": "~21.0.0",
    "@angular/language-service": "~21.0.0",
    "@capacitor/cli": "^8.3.1",
    "@eslint/eslintrc": "^3.2.0",
    "@eslint/js": "^9.17.0",
    "@ionic/angular-toolkit": "^12.1.1",
    "@nx/cypress": "22.3.3",
    "@nx/eslint": "22.3.3",
    "@nx/eslint-plugin": "22.3.3",
    "@nx/js": "22.3.3",
    "@nx/playwright": "22.3.3",
    "@nx/plugin": "22.3.3",
    "@nx/vite": "22.3.3",
    "@nx/web": "22.3.3",
    "@nx/workspace": "22.3.3",
    "@nxext/capacitor": "^21.0.0",
    "@nxext/ionic-angular": "^21.0.0",
    "@playwright/test": "^1.57.0",
    "@schematics/angular": "^21.0.0",
    "@softarc/eslint-plugin-sheriff": "^0.19.6",
    "@softarc/sheriff-core": "^0.19.6",
    "@swc-node/register": "^1.10.9",
    "@swc/core": "^1.10.4",
    "@swc/helpers": "~0.5.11",
    "@types/lodash": "^4.17.14",
    "@types/mapbox__mapbox-gl-geocoder": "^4.7.7",
    "@types/mapbox-gl": "^2.7.21",
    "@types/mocha": "^10.0.10",
    "@types/node": "^22.10.5",
    "@types/qrcode": "^1.5.6",
    "@typescript-eslint/eslint-plugin": "^8.19.0",
    "@typescript-eslint/parser": "^8.19.0",
    "@vitest/coverage-istanbul": "^4.1.0",
    "@vitest/coverage-v8": "^4.0.8",
    "@vitest/ui": "^4.1.0",
    "@wdio/allure-reporter": "^9.30.1",
    "@wdio/appium-service": "^9.30.1",
    "@wdio/cli": "^9.30.1",
    "@wdio/globals": "^9.29.1",
    "@wdio/junit-reporter": "^9.30.1",
    "@wdio/local-runner": "^9.30.1",
    "@wdio/mocha-framework": "^9.30.1",
    "@wdio/spec-reporter": "^9.30.1",
    "@wdio/types": "^9.30.1",
    "allure-commandline": "^2.43.0",
    "angular-eslint": "21.1.0",
    "appium": "3.5.2",
    "eslint": "^9.39.1",
    "eslint-config-prettier": "10.1.8",
    "eslint-plugin-import": "2.31.0",
    "eslint-plugin-jsdoc": "50.6.1",
    "eslint-plugin-playwright": "^2.1.0",
    "eslint-plugin-prefer-arrow": "1.2.3",
    "fuzzy": "^0.1.3",
    "husky": "^8.0.0",
    "inquirer": "^9.2.12",
    "inquirer-autocomplete-prompt": "^3.0.1",
    "jsdom": "^26.0.0",
    "jsonc-eslint-parser": "^2.1.0",
    "jsonc-parser": "^3.2.0",
    "ng-packagr": "21.0.1",
    "nx": "22.3.3",
    "open": "^9.1.0",
    "postcss": "^8.4.49",
    "postcss-import": "^16.1.0",
    "postcss-preset-env": "^10.1.3",
    "postcss-url": "^10.1.3",
    "prettier": "^3.4.2",
    "process": "^0.11.10",
    "ts-node": "^10.9.1",
    "tsx": "^4.23.12",
    "tty-browserify": "^0.0.1",
    "typescript": "5.9.3",
    "vitest": "^4.0.8",
    "webdriverio": "^9.30.1",
    "webpack-bundle-analyzer": "^4.10.2"
  },
  "license": "UNLICENSED",
  "name": "dispo-frontend",
  "nx": {
    "targets": {
      "test": {
        "executor": "nx:run-commands",
        "options": {
          "command": "echo 'No tests at workspace root'"
        }
      }
    }
  },
  "optionalDependencies": {
    "@nx/nx-linux-x64-gnu": "20.3.0",
    "@rollup/rollup-linux-x64-gnu": "4.59.0"
  },
  "overrides": {
    "ajv": "^8.17.1",
    "@eslint/eslintrc": {
      "ajv": "^6.12.4"
    },
    "eslint": {
      "ajv": "^6.12.4"
    },
    "koa": "2.16.3",
    "@modelcontextprotocol/sdk": "1.25.2",
    "stylus": "https://github.com/stylus/stylus/archive/refs/tags/0.64.0.tar.gz",
    "esbuild": "0.25.0"
  },
  "private": true,
  "scripts": {
    "add-dep": "npm install",
    "analyze-bundle": "npx nx build web-app --configuration=deployed --stats-json && npx webpack-bundle-analyzer dist/apps/web-app/stats.json",
    "e2e-web": "npx nx run e2e-web-app:e2e",
    "e2e-web-local": "node apps/e2e/scripts/run-local.mjs e2e-web-app:e2e:pages",
    "e2e-web-local-flows": "node apps/e2e/scripts/run-local.mjs e2e-web-app:e2e:flows",
    "e2e-web-local-record": "node apps/e2e/scripts/run-local.mjs e2e-web-app:e2e:record-pages",
    "e2e-web-local-record-flows": "node apps/e2e/scripts/run-local.mjs e2e-web-app:e2e:record-flows",
    "e2e-web-record": "npx nx run e2e-web-app:e2e:record",
    "e2e-web-record-flows": "npx nx run e2e-web-app:e2e:record-flows",
    "e2e-web-report": "npx nx run e2e-web-app:e2e:report",
    "e2e-web-ui": "npx nx run e2e-web-app:e2e:ui",
    "generate-api": "bash libs/libraries/tf-api-clients-generator/src/generate.sh",
    "install-deps": "npm ci",
    "lint": "nx run web-app:lint && nx run shared-ui:lint && nx run mobile-app:lint && nx run admin-app:lint && nx run signup-app:lint",
    "lint-admin": "nx run admin-app:lint --fix",
    "lint-shared": "nx run shared-ui:lint --fix",
    "lint-signup": "nx run signup-app:lint --fix",
    "lint-web": "nx run web-app:lint --fix",
    "start-mobile": "npx nx run mobile-app:serve:local",
    "start-mobile-proxy": "npx nx run mobile-app:serve:local-proxy",
    "prepare-husky": "cd .. && ./frontend/node_modules/.bin/husky install frontend/.husky",
    "prettier": "nx run web-app:prettier && nx run shared-ui:prettier && nx run admin-app:prettier && nx run signup-app:prettier",
    "prettier-admin": "nx run admin-app:prettier",
    "prettier-shared": "nx run shared-ui:prettier",
    "prettier-signup": "nx run signup-app:prettier",
    "prettier-web": "nx run web-app:prettier",
    "remove-deps": "rm -rf node_modules && rm -rf package-lock.json && rm -rf tmp && rm -rf dist",
    "reset-deps": "npm run remove-deps && npm run install-deps",
    "seed-local-tenants": "bash ../backend/tourfold-api/scripts/local_test_data/setup-tenants-ts/run_default.sh",
    "seed-local-signup-tenant": "bash ../backend/tourfold-api/scripts/local_test_data/setup-tenants-ts/run_local.sh --type signup",
    "restart-api": "cd ../backend/tourfold-api && ./scripts/start_api.sh",
    "reset-api-infra": "cd ../backend/tourfold-api/infrastructure && ./docker_prune.sh && ./docker_reset.sh",
    "start-admin-api": "cd ../backend/tourfold-api && ./scripts/start_admin.sh",
    "start-api": "cd ../backend/tourfold-api && ./scripts/start_api.sh",
    "sentry:sourcemaps-web": "sentry-cli sourcemaps inject --project tourfold-webapp ./dist/apps/web-app && sentry-cli sourcemaps upload --project tourfold-webapp ./dist/apps/web-app",
    "start-admin": "npx nx run admin-app:serve:local",
    "start-settings-error-proxy": "node tools/dev-proxy/settings-error-proxy.mjs",
    "start-signup": "npx nx run signup-app:serve:local",
    "start-web": "npx nx run web-app:serve:local",
    "start-web-proxy": "npx nx run web-app:serve:local-proxy",
    "test": "nx run-many --target=test --all --parallel=2",
    "test:coverage": "nx run-many --target=coverage --all --parallel=3 --exclude=dispo-frontend",
    "test:custom-objects": "nx run-many --target=test --projects=platform-schema-engine,platform-attribute-renderers,platform-object-views,shared-util,platform-plugin-engine,platform-schema-builder",
    "verify-lockfile": "npm ci --dry-run"
  },
  "trustedDependencies": [
    "@parcel/watcher",
    "@sentry/cli",
    "@swc/core",
    "core-js",
    "unrs-resolver"
  ],
  "version": "2.0.0",
  "workspaces": [
    "./apps/mobile-app",
    "./dist/libs/*"
  ]
}
